import { render, staticRenderFns } from "./FullSlideEmbeddedFrame.vue?vue&type=template&id=95d74a48&scoped=true&"
import script from "./FullSlideEmbeddedFrame.vue?vue&type=script&lang=js&"
export * from "./FullSlideEmbeddedFrame.vue?vue&type=script&lang=js&"
import style0 from "./FullSlideEmbeddedFrame.vue?vue&type=style&index=0&id=95d74a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d74a48",
  null
  
)

export default component.exports